import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Entry point remains clean. Router and HelmetProvider are managed within App.jsx
// to keep the configuration centralized and allow for better testing/SSR support.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);